/**
 * Temporary kill-switch for CRM Fleet / Cartrack.
 * Keep false until Fleet is ready to reopen — no nav, no route, no GPS polling.
 */
export const FLEET_FEATURE_ENABLED = false;
